export const TABS = ["Dashboard", "Creative", "Reports"];

export const PRICING_MODES = {
  FIXED: "fixed",
  PERCENTAGE: "percentage",
};

export const DEFAULT_PRICING_MODE = PRICING_MODES.FIXED;

// Hides content visually while keeping it for screen readers (a label for a search box, say).
export const SR_ONLY = { position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)", whiteSpace: "nowrap" };
